import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import { useTranslation } from "../../../../hooks/useTranslation";
import { EditableSettingRow } from "./PriceSettingRow/EditableSettingRow";
import { PricingRule } from "../PricingSettings";
import { useMarketplaceStore } from "../../../../store/useMarketplaceStore";

type NewRuleRowProps = {
  onClose: () => void;
};

export const NewRuleRow = (props: NewRuleRowProps) => {
  const { onClose } = props;
  const { translate } = useTranslation("pages.stores.pricingSettings");
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const methods = useForm<PricingRule>({
    mode: "onChange",
  });
  const { handleSubmit } = methods;

  const invalidate = useInvalidate();
  const { isLoading, mutate } = useCustomMutation();

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    mutate(
      {
        url: `store/${selectedCountry?.id}/price-rules`,
        method: "post",
        values: data,
        successNotification: () => {
          return {
            message: translate("successCreate"),
            type: "success",
          };
        },
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });

          onClose();
        },
      },
    );
  };

  return (
    <FormProvider {...methods}>
      <EditableSettingRow
        isLoading={isLoading}
        onClose={onClose}
        onSave={handleSubmit(onSubmit)}
      />
    </FormProvider>
  );
};
